import HasPermission from './HasPermission';

export default HasPermission;
